import { render, staticRenderFns } from "./IntroCard.vue?vue&type=template&id=915bb8dc&scoped=true&"
import script from "./IntroCard.vue?vue&type=script&lang=js&"
export * from "./IntroCard.vue?vue&type=script&lang=js&"
import style0 from "./IntroCard.vue?vue&type=style&index=0&id=915bb8dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "915bb8dc",
  null
  
)

export default component.exports